export default {
  loading: true, // return true if loading
  error: null, // an error
  dialogOpen: false, // return true if new tab's dialog is open
  tabs: [], // return the array of tabs
  createTabDialogOpened: false // return true if create tab dialog is open
}
